export function hasNew(service: unknown): service is new (...args: any) => any {
  if (typeof service !== 'function') {
    return false;
  }
  return !!service.prototype?.constructor?.name;
}
